import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyHead } from './head-manager';
import { getSeo } from './seo-data';

export default function SeoHead() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getSeo(pathname);
    applyHead(seo);
  }, [pathname]);

  return null;
}